import { render, staticRenderFns } from "./display-comment.vue?vue&type=template&id=49386ba4&scoped=true&"
import script from "./display-comment.vue?vue&type=script&lang=js&"
export * from "./display-comment.vue?vue&type=script&lang=js&"
import style0 from "./display-comment.vue?vue&type=style&index=0&id=49386ba4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49386ba4",
  null
  
)

export default component.exports